import React, { PureComponent } from 'react';
import { PieChart, Pie, ComposedChart, LineChart, Line, Area, Bar, Scatter, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { Spinner } from 'react-bootstrap';

const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
        // debugger;
      return (
        <div className="custom-tooltip">
          <div>{payload[0].payload.monthName}</div>
          <div className="tooltipTitle_yellow">EDI : {payload[0].value} %</div>
          <div className="tooltipTitle_blue">Manual Data Entry : {payload[2].value} %</div>
          <div className="tooltipTitle_green">OCR Data Entry : {payload[1].value} %</div>
        </div>
      );
    }
  
    return null;
  };

  const CustomSpinner = () => {
    return (
        <>
            <div className='col-md-6 col-xs-12 col-lg-4 col-sm-12'>
                <div className="card">
                    <MySpinner />
                    <div className="card-header blue-heading">
                        Volume of Bills by Bill Type
                    </div>
                    <div className="card-body search-form">
                        <div style={{ width: '100%', paddingTop: '25px' }} className='set-height'>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

const RenderChart = (props) => {
    let distinctYearMonth = [];
    let rows = [];
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    // const isRecordExists = (year, month) => {
    //     return rows.filter(row => row.year === year && row.month === month)
    // }
    const isYearMonthExists = (year, month) => {

        return distinctYearMonth.filter(row => row.year === year && row.month === month)
    }
    

    if (props.data.length > 0) {
        const getTotalBillsByYearMonth = (year, month) => {
            let totBill = 0;
            let totalYearMonthBills = props.data.filter(row => row.year === year && row.month === month);
    
            totalYearMonthBills.map((currRow) => {
                totBill += currRow.totalBills;
            })
    
            return totBill;
        }
    
        const getTotalBillsByYearMonthBillType = (_year, _month, _billType) => {
            debugger;
            let totBill = 0;
            let totalYearMonthBillTypeBills = props.data.filter(row => row.year === _year && row.month === _month && row.billType === _billType );
    
            totalYearMonthBillTypeBills.map((currRow) => {
                totBill += currRow.totalBills;
            })
    
            return totBill;
        }
        props.data.map((yearmonth_row) => {

            // Dib 20-11-2022
            let existingRow = isYearMonthExists(yearmonth_row.year, yearmonth_row.month)

            if (existingRow.length === 0) {

                distinctYearMonth.push({
                    _yearName: yearmonth_row.year,
                    _monthName: yearmonth_row.month
                });

                let totalYearMonthBills = getTotalBillsByYearMonth(yearmonth_row.year, yearmonth_row.month);

                // 3. filter the carrier data based on Type
                let OCR_Per = 0;
                let EDI_Per = 0;
                let PAP_Per = 0;

                let tot_edi_Bills = 0;
                let tot_ocr_Bills = 0;
                let tot_pap_Bills = 0;


                tot_edi_Bills = getTotalBillsByYearMonthBillType(yearmonth_row.year, yearmonth_row.month, "EDI");
                // EDI_Per = parseInt(tot_edi_Bills);
                EDI_Per = Math.round((parseInt(tot_edi_Bills) / parseInt(totalYearMonthBills)) * 100);


                tot_ocr_Bills = getTotalBillsByYearMonthBillType(yearmonth_row.year, yearmonth_row.month, "OCR Data Entry");

                // OCR_Per = parseInt(tot_ocr_Bills);
                OCR_Per = Math.round((parseInt(tot_ocr_Bills) / parseInt(totalYearMonthBills)) * 100);




                tot_pap_Bills = getTotalBillsByYearMonthBillType(yearmonth_row.year, yearmonth_row.month, "Manual Data Entry");
                // PAP_Per = parseInt(tot_pap_Bills);
                PAP_Per = Math.round((parseInt(tot_pap_Bills) / parseInt(totalYearMonthBills)) * 100);



                let newRow = [];
                let monthName = months[yearmonth_row.month - 1] + " " + yearmonth_row.year.toString().substring(2, 4);
                newRow = {
                    "monthName": monthName,
                    "OCR": OCR_Per,
                    "EDI": EDI_Per,
                    "PAP": PAP_Per,
                    "month": yearmonth_row.month,
                    "year": yearmonth_row.year
                }
                rows = [...rows, newRow]

                // distinctCarriers.push({
                //     _carrierKey: item.carrierKey,
                //     _carrierSCACCode: item.carrierSCACCode,
                //     _carrierName: item.carrierName,
                //     _billType: item.billType
                // });
            }

            // Dib 20-11-2022



       })
    }

    return (
        <>
            <div className='col-md-6 col-xs-12 col-lg-4 col-sm-12'>
                <div className="card">
                    <div className="card-header blue-heading">
                        Volume of Bills by Bill Type
                    </div>
                    <div className="card-body search-form">
                        <div style={{ width: '100%'}} className='set-height'>
                            <ResponsiveContainer width="93%">
                                <LineChart data={rows} height={500} width={200}>
                                    <CartesianGrid />
                                    <XAxis dataKey="monthName"
                                        interval={'preserveStartEnd'} />
                                    <YAxis></YAxis>
                                    <Legend />
                                    <Tooltip content={<CustomTooltip />} />
                                    <Line dataKey="EDI"
                                        stroke="#eac205" activeDot={{ r: 8 }} />                                    
                                    <Line dataKey="PAP" name="Manual Data Entry"
                                        stroke="#1f79a4" activeDot={{ r: 8 }} />
                                        <Line dataKey="OCR" name="OCR Data Entry"
                                        stroke="#33CC99" activeDot={{ r: 8 }} />
                                </LineChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
// const RenderChart = (props) => {
//     let rows = [];
//     const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
//     const isRecordExists = (year, month) => {
//         return rows.filter(row => row.year === year && row.month === month)
//     }

//     if (props.data.length > 0) {
//         props.data.map((row) => {
//             let OCR = 0;
//             let EDI = 0;
//             let PAP = 0;

//             const billType = row.billType;
//             const year = row.year;
//             const month = row.month;

//             if (billType === "EDI") {
//                 EDI = parseInt(row.totalBills);
//             }
//             else if (billType === "OCR") {
//                 OCR = parseInt(row.totalBills);
//             }
//             else {
//                 PAP = parseInt(row.totalBills);
//             }

//             let newRow = [];
//             let existingRow = isRecordExists(year, month);
//             let monthName = months[month - 1] + " " + year.toString().substring(2, 4);

//             if (existingRow.length === 0) {
//                 newRow = {
//                     "monthName": monthName,
//                     "OCR": OCR,
//                     "EDI": EDI,
//                     "PAP": PAP,
//                     "month": month,
//                     "year": year
//                 }
//                 rows = [...rows, newRow];
//             }
//             else {
//                 if (EDI > 0) {
//                     existingRow[0].EDI = EDI;
//                 }
//                 else if (OCR > 0) {
//                     existingRow[0].OCR = OCR;
//                 }
//                 else {
//                     existingRow[0].PAP = PAP;
//                 }
//                 const existingRows = rows.filter((r) => r.monthName !== monthName)
//                 rows = [...existingRows, existingRow[0]]
//             }
//         })
//     }

//     return (
//         <>
//             <div className='col-md-6 col-xs-12 col-lg-4 col-sm-12'>
//                 <div className="card">
//                     <div className="card-header blue-heading">
//                         Volume of Bills by Bill Type
//                     </div>
//                     <div className="card-body search-form">
//                         <div style={{ width: '100%'}} className='set-height'>
//                             <ResponsiveContainer width="93%">
//                                 <LineChart data={rows} height={500} width={200}>
//                                     <CartesianGrid />
//                                     <XAxis dataKey="monthName"
//                                         interval={'preserveStartEnd'} />
//                                     <YAxis></YAxis>
//                                     <Legend />
//                                     <Tooltip content={<CustomTooltip />} />
//                                     <Line dataKey="EDI"
//                                         stroke="#8884d8" activeDot={{ r: 8 }} />
//                                     <Line dataKey="OCR" name="OCR Data Entry"
//                                         stroke="#eac205" activeDot={{ r: 8 }} />
//                                     <Line dataKey="PAP" name="Manual Data Entry"
//                                         stroke="#1f79a4" activeDot={{ r: 8 }} />
//                                 </LineChart>
//                             </ResponsiveContainer>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </>
//     )
// }

const MySpinner = () => {
    return (
        <Spinner className='spinner-border spinner-border-chart' />
    )
}

export default function MonthWiseBillsByBillType(props) {
    if (props.loading) {
        return <CustomSpinner />
    }

    return <RenderChart data={props.data} />
}
